module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAShJREFUSA1jvKal8Z+BABCvrmHYyavHUNO3h4GHi43h4tZshjuuzgy/nz0joJN8aSbytdJW56jDSA3f0RAbDTFSQ4BU9YM2jbGI19QS9AyXiQkDw42fKOpEc/MY/n79iiJGTQ7LDh4dwubd+MFw+tJTsLrff/4yLNt8iYGBUZGBgYewVnJVMCo59BGsksg1nBJ9LKC6jxgACqmfv/4yMAIVcxOphxhzcalh/A8EuCSRxZdvvoxSiSPL0YLNAmolEAKghM7AqISi7EFsNMOfFy9QxKjJYSGm6fL3yxcGBl5Ua0GOIkYvqi7ieYO2HBt1GPGRCFE5GmKjIUZqCJCqnoWBkbGbkKY/z56riAvyqoUYCgmxsTD9+7x371NglXECqBe1yUHIIBLkAafcTuTKLouIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Norway.png
// module id = 481
// module chunks = 7